import { render, staticRenderFns } from "./qualityReviewList.vue?vue&type=template&id=71ecf108"
import script from "./qualityReviewList.vue?vue&type=script&lang=js"
export * from "./qualityReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports